<h3>{{name}}</h3>
<p>{{theory}}</p>
<h4>Список заданий</h4>
<ul>
    <li  *ngFor="let task of tasks; let i = index;"> 
        <i class="fas fa-long-arrow-alt-right"></i> <a [routerLink]="['run/', task.id]">{{i+1}}. {{task.name}}</a>
    </li>
</ul>